var $cf5c07b2213e6c10$exports = {};
$cf5c07b2213e6c10$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Data selectat\u{103} nu este disponibil\u{103}`,
            other: `Datele selectate nu sunt disponibile`
        })}.`
};


export {$cf5c07b2213e6c10$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
